import { render, staticRenderFns } from "./becameAgentTime.vue?vue&type=template&id=2b9d015a&scoped=true"
import script from "./becameAgentTime.vue?vue&type=script&lang=js"
export * from "./becameAgentTime.vue?vue&type=script&lang=js"
import style0 from "./becameAgentTime.vue?vue&type=style&index=0&id=2b9d015a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d015a",
  null
  
)

export default component.exports